var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "m_join"
  }, [_vm.success ? _c('span', [_c('h2', [_vm._v($t("arke8k4", "加入成功"))])]) : _c('span', [_c('h2', [_vm._v($t("froj7f4", "确认加入"))]), _c('h2', [_vm._v(_vm._s(_vm.name || "xxx"))]), _c('div', {
    staticClass: "submit"
  }, [_c('Button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v($t("l9122", "确认"))])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };